export const slugify = (text) => {
	return text.toString().toLowerCase()
		.replace(/\s+/g, '-') // Replace spaces with -
		.replace(/[^\w-]+/g, '') // Remove all non-word chars
		.replace(/--+/g, '-') // Replace multiple - with single -
		.trim()
};



// WEBPACK FOOTER //
// ./src/components/MainMenu/functions.js